<template>
	<label class="toggle" :for="`toggle_${id}`">
		<span class="toggle__label">
			<slot></slot>
		</span>
		<input
			:id="`toggle_${id}`"
			class="toggle__input"
			:name="name"
			type="checkbox"
			:checked="checked"
			:disabled="$attrs.disabled"
			@change="onChange"
		/>
		<div class="toggle__fill"></div>
	</label>
</template>

<script>
export default {
	props: {
		id: {
			type: String,
			default: ''
		},
		value: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			checked: this.value
		};
	},
	methods: {
		onChange() {
			this.checked = !this.checked;
			this.$emit('input', this.checked);
		}
	}
};
</script>

<style></style>
